import { ArrowLeft } from 'lucide-react';

import useJobBackButton from './useJobBackButton';

const JobBackButton: React.FunctionComponent = function () {
  const { onBackClick } = useJobBackButton();
  return (
    <button
      className="flex flex-row gap-x-2 hover:bg-neutral-300 w-max px-3 md:px-4 py-2 rounded-full text-14-22 text-neutral-700"
      onClick={onBackClick}
      id="back-to-quote"
      type="button"
    >
      <ArrowLeft size={22} />
      Back to quote review
    </button>
  );
};

export default JobBackButton;
